import React, { useState, useEffect } from 'react';
import './Auth.css';

const Auth = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Check if user is already authenticated (stored in sessionStorage)
    const authStatus = sessionStorage.getItem('farmbalance_authenticated');
    if (authStatus === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    // Get password from environment variable (fallback for development)
    const correctPassword = process.env.REACT_APP_ACCESS_PASSWORD || 'FB_Res2025!@';
    
    // Debug logging (remove in production)
    console.log('Environment password:', correctPassword);
    console.log('Input password:', password);
    console.log('Passwords match:', password === correctPassword);

    // Simple password check
    if (password === correctPassword) {
      setIsAuthenticated(true);
      sessionStorage.setItem('farmbalance_authenticated', 'true');
    } else {
      setError(`Incorrect password. Please try again. (Expected: ${correctPassword ? 'Set' : 'Not set'})`);
    }

    setLoading(false);
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    sessionStorage.removeItem('farmbalance_authenticated');
    setPassword('');
  };

  if (isAuthenticated) {
    return (
      <div style={{position: 'relative'}}>
        <button onClick={handleLogout} className="auth-simple-logout-btn">
          Logout
        </button>
        {children}
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-logo">
          <img src="/farmbalance_logo.png" alt="FarmBalance" className="auth-logo-img" />
        </div>
        <h2>Access Required</h2>
        <p>Please enter the password to access the FarmBalance resilience application.</p>
        
        <form onSubmit={handleLogin} className="auth-form">
          <div className="auth-input-group">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              className="auth-input"
              required
            />
          </div>
          
          {error && <div className="auth-error">{error}</div>}
          
          <button 
            type="submit" 
            className="auth-submit-btn"
            disabled={loading}
          >
            {loading ? 'Checking...' : 'Access Application'}
          </button>
        </form>
        
        <div className="auth-footer">
          <p>Authorized users only</p>
        </div>
      </div>
    </div>
  );
};

export default Auth;